import ICOABI from "../ABI/ICOABI.json"
import tokenABI from "../ABI/BEP20ABI.json"
import PABI from "../ABI/PriceProvider.json";
import Web3 from "web3";
import { convert } from "../helper/convert";
import { Multicall } from "multicall";
import config from "../config/config";
import { getFormatMulticall, formatNumber } from "../helper/custommath";
import { connection } from "../helper/connection";
import { toastAlert } from "../helper/toastAlert";

import { savePurchase } from "../ApiAction/api"

export async function getBalanceInfo(address) {


    try {
        var get = await connection();
        var address = get.address;
        if (!address) {
            address = "0x0000000000000000000000000000000000000000"
        }
        var web3 = new Web3(config.rpcUrl);
        const multicall = new Multicall({
            web3Instance: web3,
        });

        var Contract = [
            {
                reference: "balanceOf",
                contractAddress: "0x9336E83E6Bb110899b40bC10B74E2E9fECF7922D",
                abi: tokenABI,
                calls: [
                    {
                        reference: "balanceOf",
                        methodName: "balanceOf",
                        methodParameters: [address],
                    },
                    {
                        reference: "allowance",
                        methodName: "allowance",
                        methodParameters: [address, config.contractAddress],
                    },
                ]
            },
            {
                reference: "tokenprice",
                contractAddress: config.contractAddress,
                abi: ICOABI,
                calls: [
                    {
                        reference: "getTokenprice",
                        methodName: "getTokenprice",
                        methodParameters: [],
                    },
                    {
                        reference: "totalreward",
                        methodName: "totalreward",
                        methodParameters: [],
                    }
                ]
            },
            {
                reference: "latestAnswer",
                contractAddress: config.priceProvider,
                abi: PABI,
                calls: [
                    {
                        reference: "latestAnswer",
                        methodName: "latestAnswer",
                        methodParameters: [],
                    }
                ]
            },
        ];


        const results = await multicall.call(Contract);
        var balanceOf = await getFormatMulticall(results, "balanceOf", 0);
        balanceOf = parseInt(balanceOf.hex) / 10 ** 18;
        var allowance = await getFormatMulticall(results, "balanceOf", 1);
        allowance = parseInt(allowance.hex) / 10 ** 18;
        var tokenprice = await getFormatMulticall(results, "tokenprice", 0);
        tokenprice = parseInt(tokenprice?.hex);

        var coinbalance = await web3.eth.getBalance(address);
        coinbalance = coinbalance / 10 ** 18

        var latestAnswer = await getFormatMulticall(results, "latestAnswer", 0);
        latestAnswer = parseInt(latestAnswer?.hex);

        var totalreward = await getFormatMulticall(results, "latestAnswer", 0);
        totalreward = parseInt(totalreward?.hex) / 10 ** 18;

        var totalSupply = 10000000;

        let sold = totalreward;
        let total = 200000;
        let soldOutPerc = (sold / total) * 100;
        var remaning = totalSupply - totalreward;
        remaning = formatNumber(remaning, 2)

        return {
            balanceOf,
            allowance,
            tokenprice,
            coinbalance,
            bnbPrice: latestAnswer,
            totalreward,
            remaning,
            soldOutPerc: formatNumber(soldOutPerc, 2),
            totalSupply
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerr211212')
        return {
            balanceOf: 0,
            allowance: 0,
            tokenprice: 0,
            coinbalance: 0,
            bnbPrice: 0,
            totalreward: 0,
            remaning: 0,
            soldOutPerc: 0,
            totalSupply: 0
        };
    }

}


export async function approveToken(address, transport) {

    var tkn = 1000 * 10 ** 18;
    tkn = convert(tkn.toString());

    try {
        var get = await connection();
        var address = get.address;
        var web3 = get.web3;
        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(tokenABI, config.usdtContract);

        var estimateGas = await Contractsss.methods.approve(
            config.contractAddress,
            tkn
        ).estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.approve(
            config.contractAddress,
            tkn
        ).send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas });

        var approvalAmt = (result && result.events && result.events.Approval && result.events.Approval.returnValues
            && result.events.Approval.returnValues && result.events.Approval.returnValues
            && result.events.Approval.returnValues.value) ?
            parseFloat(result.events.Approval.returnValues.value) : 0
        approvalAmt = approvalAmt / 10 ** 18;

        return {
            approvalAmt: approvalAmt,
            isAllowed: (result && result.status) ? result.status : false,
            error: ""
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerrerr121212')
        var error = err.toString();
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }

        return {
            approvalAmt: 0,
            isAllowed: false,
            error: message
        }

    }

}


export async function buyToken(amount) {
    try {
        var get = await connection();
        var address = get.address;
        var web3 = get.web3;
        var currnetwork = await web3.eth.net.getId();
        if (currnetwork != config.network) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please login into bsc chain.`
            }
        }

        var tkn = amount * 10 ** 18;
        tkn = tkn.toString();
        tkn = convert(tkn);

        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(ICOABI, config.contractAddress);
        var estimateGas = await Contractsss.methods.depositUSDT(
            tkn,
        ).estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.depositUSDT(
            tkn,
        ).send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas });

        let transactionHash = result?.transactionHash;
        let reward = result?.events?.Deposit?.returnValues?.amount || 0;

        savePurchase({
            address,
            txId: transactionHash,
            amount: amount,
            receive: reward / 10 ** 18,
            symbol: "USDT"
        });
        return {
            status: (result && result.status) ? result.status : false,
            error: "",
            txId: transactionHash,
            reward: reward ? parseInt(reward) / 10 ** 18 : 0,
            message: ""
        }

    } catch (err) {
        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }
        return {
            status: false,
            message: message,
            txId: "",
            reward: 0
        }

    }

}

export async function buyCoin(amount) {
    try {
        var get = await connection();
        var address = get.address;
        var web3 = get.web3;
        var currnetwork = await web3.eth.net.getId();
        console.log("222222222222A")
        if (currnetwork != config.network) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please login into bsc chain.`
            }
        }
        console.log("222222222222B")
        var tkn = amount * 10 ** 18;
        tkn = tkn.toString();
        tkn = convert(tkn);
        console.log(address, tkn, 'tkntkntkntkntkntkntkn')
        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(ICOABI, config.contractAddress);
        var estimateGas = await Contractsss.methods.depositBNB().estimateGas({ from: address, value: tkn });
        estimateGas = parseInt(estimateGas) + 30000;

        let gasVal = estimateGas * 10 ** 18;
        var totalGas = parseFloat(gasVal) + parseFloat(tkn);
        totalGas = totalGas / 10 ** 18

        if (parseFloat(estimateGas) / 10 ** 8 > balance || totalGas > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.depositBNB().send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas, value: tkn });

        console.log(result, 'resultresultresult121212')

        let transactionHash = result?.transactionHash;
        let reward = result?.events?.Deposit?.returnValues?.amount || 0;

        savePurchase({
            address,
            txId: transactionHash,
            amount: amount,
            receive: reward / 10 ** 18,
            symbol: "BNB"
        });

        return {
            status: (result && result.status) ? result.status : false,
            error: "",
            txId: transactionHash,
            reward: reward ? parseInt(reward) / 10 ** 18 : 0,
            message: ""
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerr233423232323', err?.error?.message)
        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }
        return {
            status: false,
            message: message,
            txId: "",
            reward: 0
        }

    }

}

export async function getInfo() {
    try {
        var web3 = new Web3(config.rpc);
        let icoContract = new web3.eth.Contract(ICOABI, config.contractAddress);
        var totalreward = await icoContract.methods.totalreward().call();
        totalreward = formatNumber(parseFloat(totalreward) / 10 ** 18, 4)
        return totalreward;
    } catch (err) {
        return 0;
    }

}


export function validatePurchase(pay, balanceallowance, isBuy) {
    var isError = false;
    var errMsg = "";
    if (!pay || pay == 0 || pay == "0") {
        isError = true;
        errMsg = "Please enter amount";
    } else {
        if (isBuy == "USDT") {
            if (parseFloat(pay) < 1) {
                isError = true;
                errMsg = "The minimum deposit amount is 1 USDT";
            }
            if (parseFloat(pay) > parseFloat(balanceallowance?.balance)) {
                isError = true;
                errMsg = "Insufficient USDT balance";
            }
        } else if (isBuy == "BNB") {
            if (parseFloat(pay) < 0.001) {
                isError = true;
                errMsg = "The minimum deposit amount is 0.001 BNB";
            }
            if (parseFloat(pay) > parseFloat(balanceallowance?.coinbalance)) {
                isError = true;
                errMsg = "Insufficient BNB balance";
            }
        } else {
            isError = true;
            errMsg = "Please try again later";
        }
    }

    return {
        isError,
        errMsg

    }

}